import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  size?: 'default' | 'large';
}
export function CTAButton({
  children,
  onClick,
  className = '',
  size = 'default'
}: CTAButtonProps) {
  const sizeClasses = size === 'large' ? 'px-12 py-5 text-xl md:text-2xl' : 'px-8 py-4 text-lg md:text-xl';
  return <button onClick={onClick} className={`
        bg-[var(--accent-orange)] 
        hover:bg-[var(--accent-orange-hover)] 
        text-white 
        font-bold 
        rounded-lg 
        transition-all 
        duration-300 
        transform 
        hover:scale-105 
        hover:shadow-2xl
        hover:shadow-orange-500/50
        uppercase
        tracking-wide
        ${sizeClasses}
        ${className}
      `} aria-label={typeof children === 'string' ? children : 'Call to action button'} data-id="element-33">
      {children}
    </button>;
}